function getRelativeLuminance(red, green, blue) {
  const RED_LUMINANCE = 0.2126;
  const GREEN_LUMINANCE = 0.7152;
  const BLUE_LUMINANCE = 0.0722;
  const MAX_LUMINANCE = 255;

  return (
    (RED_LUMINANCE * red + GREEN_LUMINANCE * green + BLUE_LUMINANCE * blue) /
    MAX_LUMINANCE
  );
}

function isColorDark(hexColor) {
  const values = hexColor.replace('#', '');

  const red = parseInt(values.substr(0, 2), 16);
  const green = parseInt(values.substr(2, 2), 16);
  const blue = parseInt(values.substr(4, 2), 16);

  const relativeLuminance = getRelativeLuminance(red, green, blue);

  return relativeLuminance <= 0.5;
}

export default isColorDark;
